import { useEffect, useMemo } from 'react';
import { inAppHelpActions } from '../reducers';
import { addAcademyHelpParamsToWindow, addHelpParamsToWindow, getHelpConfig, loadZorse, shouldShowZorse } from '../utils/inAppHelp';
import { useAppDispatch } from '../../../hooks';
import { useUser } from '../../../hooks/useNavConfig';
import { isGlobalNavAcademyMode } from '../../../utils/navEnviro';
import { loadDependentScript } from '../../../components/loadNavigationApps/utils/loadDependentScript';
function loadHelpCta(scopes, displayLanguage, isHublessNav) {
  let shouldShowHelpInToolbar;
  let helpCtaScript = () => {};
  const {
    help015,
    help030,
    help040,
    help044,
    help063,
    isHelpShownInToolbar
  } = getHelpConfig(scopes, displayLanguage);
  if (!isHublessNav && isGlobalNavAcademyMode()) {
    // Hubful nav in Academy app. Global toolbar is not shown in thes apps.
    shouldShowHelpInToolbar = false;
    addAcademyHelpParamsToWindow({
      help015,
      help030,
      help040,
      help044,
      help063
    });
    if (shouldShowZorse()) {
      helpCtaScript = () => loadZorse();
    }
  } else {
    shouldShowHelpInToolbar = isHelpShownInToolbar;
    addHelpParamsToWindow({
      help015,
      help030,
      help040,
      help044,
      help063
    }, isHelpShownInToolbar);
    if (shouldShowZorse()) {
      helpCtaScript = loadZorse;
    }
  }
  loadDependentScript(helpCtaScript, 500);
  return {
    shouldShowHelpInToolbar
  };
}
export function useLoadHelpCta(isHublessNav) {
  const dispatch = useAppDispatch();
  const {
    scopes,
    displayLanguage
  } = useUser();
  const {
    shouldShowHelpInToolbar
  } = useMemo(() => loadHelpCta(scopes, displayLanguage, isHublessNav), [displayLanguage, isHublessNav, scopes]);
  useEffect(() => {
    dispatch(inAppHelpActions.setShouldShowHelpInToolbar(shouldShowHelpInToolbar));
  }, [dispatch, shouldShowHelpInToolbar]);
  return {
    shouldShowHelpInToolbar
  };
}